import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
/* eslint-disable react/no-array-index-key */

import React from 'react';
import { Grid } from 'semantic-ui-react'; // TODO remove negative margin from grid in semantic

var Footer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Footer, _React$Component);

  function Footer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Footer.prototype;

  _proto.getContainerClassNames = function getContainerClassNames() {
    var _this$props = this.props,
        className = _this$props.className,
        backgroundColor = _this$props.backgroundColor;
    return this.isInColorPalette() ? (className && className + " ") + "footer-container-" + backgroundColor : '';
  };

  _proto.getContainerStyle = function getContainerStyle() {
    var backgroundColor = this.props.backgroundColor;
    return !this.isInColorPalette() && backgroundColor !== 'none' ? {
      backgroundColor: backgroundColor
    } : {};
  };

  _proto.isInColorPalette = function isInColorPalette() {
    var backgroundColor = this.props.backgroundColor;
    return backgroundColor === 'primary' || backgroundColor === 'secondary';
  };

  _proto.renderFooterColumns = function renderFooterColumns() {
    var _this$props2 = this.props,
        columns = _this$props2.columns,
        verticalAlign = _this$props2.verticalAlign,
        horizontalAlign = _this$props2.horizontalAlign;
    return /*#__PURE__*/React.createElement(Grid, {
      columns: columns.length,
      verticalAlign: verticalAlign,
      textAlign: horizontalAlign,
      stackable: true
    }, columns.map(function (column, index) {
      return /*#__PURE__*/React.createElement(Grid.Column, {
        key: index
      }, column);
    }));
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.getContainerClassNames(),
      style: this.getContainerStyle()
    }, this.renderFooterColumns());
  };

  return Footer;
}(React.Component);

export { Footer as default };
Footer.defaultProps = {
  backgroundColor: '',
  className: '',
  columns: [],
  horizontalAlign: 'center',
  verticalAlign: 'middle'
};
Footer.propOptions = {
  backgroundColor: ['primary', 'secondary', 'default']
};